const TEMPLATE_NAME = 'REPORT_AUDIT_ANSWERS';

const initialState = () => ({
  loading: false,
  visitation: {},
  loadedData: {},
  auditedAnswers: {},
  canChangeTheMenu: true,
  isThereErrorIncurrentForm: null,
  wasCreated: false
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_FULFILLED`: {
      const dataFromRequest = action.payload;
      const { steps, visitation, visitationAuditorship } = dataFromRequest;

      const loadedData = steps;
      const auditedAnswers = steps;

      return {
        ...state,
        loading: false,
        visitation,
        visitationAuditorship,
        loadedData,
        auditedAnswers
      };
    }
    case `${TEMPLATE_NAME}_CREATE_FULFILLED`: {
      return {
        ...state,
        wasCreated: true
      };
    }
    case `${TEMPLATE_NAME}_UPDATE`: {
      const newData = action.payload;

      return {
        ...state,
        loading: false,
        auditedAnswers: newData
      };
    }
    case `${TEMPLATE_NAME}_MENU_CHANGE_STATUS`: {
      const newStatus = action.payload;

      return {
        ...state,
        loading: false,
        canChangeTheMenu: newStatus
      };
    }
    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }
    default:
      return state;
  }
};
export default reducer;
